export default __webpack_public_path__ + "static/media/3.ec7f0724.png";